import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ORDER_STATUS, formatRange, rupiah, waLink } from "@/lib/format";

const HEADERS = ["Kode", "Tamu", "Trip / Paket", "Tanggal", "Pax", "Total", "Dibayar", "Status", ""];

export const StatusSelect = ({ value, onChange, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className={`h-8 w-[178px] text-xs ${ORDER_STATUS[value]?.cls || ""}`}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {Object.entries(ORDER_STATUS).map(([key, meta]) => (
        <SelectItem key={key} value={key} data-testid={`${testId}-option-${key}`}>{meta.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

const OrderRow = ({ order: o, onEdit, onDelete, onStatus }) => {
  const remaining = Math.max(0, o.total_price - o.amount_paid);
  return (
    <TableRow className="border-white/5 hover:bg-white/[0.02]" data-testid={`admin-order-row-${o.id}`}>
      <TableCell className="whitespace-nowrap font-mono text-gold-light">{o.code}</TableCell>
      <TableCell className="min-w-[150px]">
        <p className="font-medium">{o.customer_name}</p>
        <a href={waLink(o.phone)} target="_blank" rel="noreferrer" className="text-xs text-neutral-500 hover:text-gold">{o.phone}</a>
      </TableCell>
      <TableCell className="min-w-[160px]">
        <p>{o.trip_name}</p>
        <p className="text-xs text-neutral-500">{o.package_name}</p>
      </TableCell>
      <TableCell className="whitespace-nowrap text-sm">{formatRange(o.start_date, o.end_date)}</TableCell>
      <TableCell className="font-mono">{o.participants}</TableCell>
      <TableCell className="whitespace-nowrap font-mono">{rupiah(o.total_price)}</TableCell>
      <TableCell className="whitespace-nowrap font-mono">
        {rupiah(o.amount_paid)}
        {remaining > 0 && o.status !== "batal" && <p className="text-xs text-rose-300/80">sisa {rupiah(remaining)}</p>}
      </TableCell>
      <TableCell><StatusSelect value={o.status} onChange={(s) => onStatus(o, s)} testId={`admin-order-status-${o.id}`} /></TableCell>
      <TableCell>
        <div className="flex justify-end gap-1">
          <Button size="icon" variant="ghost" onClick={() => onEdit(o)} data-testid={`admin-order-edit-${o.id}`}><Pencil /></Button>
          <Button size="icon" variant="ghost" className="hover:text-rose-400" onClick={() => onDelete(o)} data-testid={`admin-order-delete-${o.id}`}><Trash2 /></Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export const OrdersTable = ({ orders, ...handlers }) => (
  <div className="panel scroll-thin overflow-x-auto" data-testid="admin-orders-table">
    <Table>
      <TableHeader>
        <TableRow className="border-white/10 hover:bg-transparent">
          {HEADERS.map((h) => <TableHead key={h} className="whitespace-nowrap text-[11px] uppercase tracking-[0.15em] text-neutral-500">{h}</TableHead>)}
        </TableRow>
      </TableHeader>
      <TableBody>
        {orders.map((o) => <OrderRow key={o.id} order={o} {...handlers} />)}
      </TableBody>
    </Table>
  </div>
);
